export default {
  credentials: [
    {
      id: '5a37c114340c842701472453',
      name: 'NicOud Fulfilment Updates Lambda',
      redirectURI: 'http://0.0.0.0',
      trusted: true,
      project: {
        id: '58ad512331c7ee34011d6ba1',
        name: 'HC One Shop',
        customer: '58ad511931c7ee34011d6ba0',
        active: true,
        currencyCode: 'EUR',
        currencyName: 'Euro',
        currencySymbol: '€',
        createdAt: '2017-02-22T08:51:47.571Z',
        updatedAt: '2017-02-22T08:51:47.571Z'
      },
      clientId: 'D66AUOJ43S',
      clientSecret: 'jeRhOAxS39jaZoncWTHm28RCNF2uZF',
      createdAt: '2017-12-18T13:22:28.005Z',
      updatedAt: '2017-12-18T13:22:28.005Z'
    }
  ],

  projects: [
    {
      id: '5846dcb5e2425f6d010d08d0',
      name: 'Gazelle NL',
      slug: 'gazelle-nl',
      customer: '5846dc33e2425f6d010d08cb',
      active: true,
      currencyCode: 'EUR',
      currencyName: 'Euro',
      currencySymbol: '€',
      createdAt: '2016-12-06T15:43:49.753Z',
      updatedAt: '2016-12-06T15:43:49.753Z',
      domains: ['gazelle-nl.iloyaltyserver.com', 'nl.gazellebrandstore.com']
    }
  ],

  customers: [
    {
      id: '58de0e8a4d367834016fb1b1',
      name: 'Lasaulec',
      contactName: 'Chris Bavinck',
      contactEmail: 'lasaulec@loyaltymakers.nl',
      contactRole: 'Projectleider',
      contactCompany: 'Loyalty Makers',
      active: true,
      createdAt: '2017-03-31T08:08:42.369Z',
      updatedAt: '2017-03-31T08:08:42.369Z'
    },

    {
      id: '5820f533cb85a23301390fd3',
      name: 'AUV',
      contactName: 'AUV',
      contactEmail: 'auv@loyaltymakers.nl',
      contactRole: 'admin',
      contactCompany: 'AUV',
      active: false,
      createdAt: '2016-11-07T21:42:11.056Z',
      updatedAt: '2016-11-07T21:42:11.056Z'
    },

    {
      id: '5846db82e2425f6d010d08c5',
      name: 'Gazelle UK',
      contactName: 'gazelle-uk',
      contactEmail: 'gazelle-uk@loyaltymakers.nl',
      contactRole: 'Conctact',
      contactCompany: 'Gazelle',
      active: true,
      createdAt: '2016-12-06T15:38:42.532Z',
      updatedAt: '2016-12-06T15:38:42.532Z'
    },

    {
      id: '5846dc33e2425f6d010d08cb',
      name: 'Gazelle NL',
      contactName: 'gazelle-nl',
      contactEmail: 'gazelle-nl@loyaltymakers.nl',
      contactRole: 'Contact',
      contactCompany: 'Gazelle',
      active: true,
      createdAt: '2016-12-06T15:41:39.343Z',
      updatedAt: '2016-12-06T15:41:39.343Z'
    },

    {
      id: '5846dc4ae2425f6d010d08cc',
      name: 'Gazelle FR',
      contactName: 'gazelle-fr',
      contactEmail: 'gazelle-fr@loyaltymakers.nl',
      contactRole: 'Contact',
      contactCompany: 'Gazelle',
      active: true,
      createdAt: '2016-12-06T15:42:02.688Z',
      updatedAt: '2016-12-06T15:42:02.688Z'
    },

    {
      id: '5846dc67e2425f6d010d08cd',
      name: 'Gazelle DK',
      contactName: 'gazelle-dk',
      contactEmail: 'gazelle-dk@loyaltymakers.nl',
      contactRole: 'Contact',
      contactCompany: 'Gazelle',
      active: true,
      createdAt: '2016-12-06T15:42:31.471Z',
      updatedAt: '2016-12-06T15:42:31.471Z'
    },

    {
      id: '5846dc7ce2425f6d010d08ce',
      name: 'Gazelle DE',
      contactName: 'gazelle-de',
      contactEmail: 'gazelle-de@loyaltymakers.nl',
      contactRole: 'Contact',
      contactCompany: 'Gazelle',
      active: true,
      createdAt: '2016-12-06T15:42:52.357Z',
      updatedAt: '2016-12-06T15:42:52.357Z'
    },

    {
      id: '5846dc95e2425f6d010d08cf',
      name: 'Gazelle AT',
      contactName: 'gazelle-at',
      contactEmail: 'gazelle-at@loyaltymakers.nl',
      contactRole: 'Contact',
      contactCompany: 'Gazelle',
      active: true,
      createdAt: '2016-12-06T15:43:17.741Z',
      updatedAt: '2016-12-06T15:43:17.741Z'
    }
  ]
}



// WEBPACK FOOTER //
// ./mockdata.js